// export const SERVER_URI = "http://localhost:5000"; // development
export const SERVER_URI = "https://emaildb-server.onrender.com"; // production
